import angular from 'angular';

import { STICKY_CONTAINER_FOR_COLUMN_CLONE_ID, STICKY_COLUMN_CLONE_CLASS } from '../constants';

export default function shiftsStickyUserColumn(WindowScroll, $compile) {
  'ngInject';

  return {
    restrict: 'A',
    compile(element) {
      const rawElementHTML = element[0].outerHTML;
      const stickyColumnCloneHolderElement = angular.element(
        document.getElementById(STICKY_CONTAINER_FOR_COLUMN_CLONE_ID)
      );

      return {
        post($scope, $element, $attrs) {
          let cloneElement = null;

          function add() {
            cloneElement = angular.element(rawElementHTML);
            cloneElement
              .removeAttr('shifts-sticky-user-column') // prevent infinite loop
              .addClass(STICKY_COLUMN_CLONE_CLASS);

            $element.closest('.shifts-content-container').prepend(cloneElement);
            $compile(cloneElement)($scope);
            stickyColumnCloneHolderElement.html(''); // clear it
          }

          function remove() {
            if (cloneElement) {
              cloneElement.remove();
              cloneElement = null;
              stickyColumnCloneHolderElement.html(''); // clear it
            }
          }

          $scope.$on('$destroy', remove);
          $scope.$watch($attrs.shiftsStickyUserColumn, (val) => (val ? add() : remove()));
        },
      };
    },
  };
}
